import {
    ClickElement,
    ClickText,
    ClickType,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackOpenCalendarClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.OpenCalendar,
            click_text: ClickText.OpenCalendar,
        },
    });
}

async function trackCalendarAddToCartClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickEcomCta,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.AddToCart,
            click_text: ClickText.BuyVoucher,
            click_type: ClickType.FromCalendar,
        },
    });
}

export { trackCalendarAddToCartClicked, trackOpenCalendarClicked };
